// react
import React from "react";

// react router dom
import { Link } from "react-router-dom";

// components
import { Badge } from "antd";

const SideDrawerItemLabel = (props) => {
  const { route, sideDrawerItemCount } = props;

  return (
    <div className="d-flex justify-content-between align-items-center">
      {route.page ? (
        <Link to={route.path} className="text-truncate">
          {route.label}
        </Link>
      ) : (
        route.label
      )}

      {sideDrawerItemCount !== undefined && (
        <Badge
          showZero={true}
          overflowCount={999}
          count={sideDrawerItemCount}
          style={{
            backgroundColor: "#FFF",
            color: "#122955",
          }}
        />
      )}
    </div>
  );
};

export default SideDrawerItemLabel;
